export default "__VITE_ASSET__DgLQgM5t__"